<!--
    Summary:
        合作
    ChangeLog:
        Labbor on 2020/2/21 added
-->
<template>
  <div class="v-partnership">
    <banner>
      <img src="../../assets/images/about/Header_1920x380_partner.jpg"/>
      <div slot="title">{{$t('Partnership.Title')}}</div>
    </banner>
    <div class="c">
      <p class="p">
        {{$t('Partnership.P1Title')}}
      </p>
      <div class="detail">
        <div class="svg">
          <svg x="0px" y="0px" width="118px" height="97px" viewBox="0 0 118 97" enable-background="new 0 0 118 97" xml:space="preserve">
            <g>
              <path d="M31.1,73.998c5.688-7.111,8.535-14.316,8.535-21.617c0-3.09-0.371-5.751-1.113-7.978c-4.332,3.34-9.031,5.009-14.102,5.009
                c-6.929,0-12.71-2.194-17.349-6.586c-4.639-4.389-6.958-10.298-6.958-17.72c0-6.926,2.348-12.71,7.051-17.349
                c4.7-4.639,10.452-6.958,17.256-6.958c9.77,0,17.256,4.021,22.451,12.061c4.329,6.68,6.494,15.029,6.494,25.049
                c0,12.742-3.247,24.154-9.741,34.234C37.13,82.227,27.325,90.357,14.215,96.541l-3.525-6.865
                C18.604,86.336,25.409,81.113,31.1,73.998z M95.67,73.998c5.688-7.111,8.535-14.316,8.535-21.617c0-3.09-0.371-5.751-1.113-7.978
                c-4.206,3.34-8.906,5.009-14.102,5.009c-6.804,0-12.556-2.194-17.256-6.586c-4.702-4.389-7.051-10.298-7.051-17.72
                c0-4.575,1.113-8.721,3.34-12.432s5.195-6.616,8.906-8.721c3.711-2.102,7.729-3.154,12.061-3.154
                c9.771,0,17.256,4.021,22.451,12.061c4.329,6.68,6.494,15.029,6.494,25.049c0,12.742-3.247,24.154-9.741,34.234
                C101.7,82.227,91.896,90.357,78.785,96.541l-3.525-6.865C83.175,86.336,89.979,81.113,95.67,73.998z"></path>
            </g>
          </svg>
        </div>
        <h2 class="h2">
          {{$t('Partnership.P1Detail')}}
        </h2>
      </div>
      <p class="p">
        {{$t('Partnership.P1Detail2')}}
      </p>
    </div>
  </div>
</template>

<script>
  import banner from '@/components/banner'

  export default {
    components: {
      banner,
    },
    data() {
      return {}
    },
    methods: {},
  }
</script>

<style scoped lang="scss">
  .v-partnership {
    text-align: left;

    .c {
      width: 1200px;
      margin: 0 auto;
      padding: 60px 0;

      .detail {
        margin-top: 50px;
        margin-bottom: 50px;
        display: flex;
        align-items: center;
        color: #368da7;

        .svg {
          fill: #368da7;
          width: 165px;
          margin-right: 50px;
        }
      }
    }

  }
</style>



// WEBPACK FOOTER //
// src/view/about/partnership.vue